var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38.52 33.37L21.36 16.2A63.6 63.6 0 0 1 59.5.16v24.3a39.5 39.5 0 0 0-20.98 8.92z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.52 33.37L21.36 16.2A63.6 63.6 0 0 1 59.5.16v24.3a39.5 39.5 0 0 0-20.98 8.92z",
    fill: "#c0c0c0",
    fillOpacity: 0.25,
    transform: "rotate(45 64 64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.52 33.37L21.36 16.2A63.6 63.6 0 0 1 59.5.16v24.3a39.5 39.5 0 0 0-20.98 8.92z",
    fill: "#c0c0c0",
    fillOpacity: 0.25,
    transform: "rotate(90 64 64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.52 33.37L21.36 16.2A63.6 63.6 0 0 1 59.5.16v24.3a39.5 39.5 0 0 0-20.98 8.92z",
    fill: "#c0c0c0",
    fillOpacity: 0.25,
    transform: "rotate(135 64 64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.52 33.37L21.36 16.2A63.6 63.6 0 0 1 59.5.16v24.3a39.5 39.5 0 0 0-20.98 8.92z",
    fill: "#c0c0c0",
    fillOpacity: 0.25,
    transform: "rotate(180 64 64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.52 33.37L21.36 16.2A63.6 63.6 0 0 1 59.5.16v24.3a39.5 39.5 0 0 0-20.98 8.92z",
    fill: "#c0c0c0",
    fillOpacity: 0.25,
    transform: "rotate(225 64 64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.52 33.37L21.36 16.2A63.6 63.6 0 0 1 59.5.16v24.3a39.5 39.5 0 0 0-20.98 8.92z",
    fill: "#c0c0c0",
    fillOpacity: 0.25,
    transform: "rotate(270 64 64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.52 33.37L21.36 16.2A63.6 63.6 0 0 1 59.5.16v24.3a39.5 39.5 0 0 0-20.98 8.92z",
    fill: "#c0c0c0",
    fillOpacity: 0.25,
    transform: "rotate(315 64 64)"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "discrete",
    dur: "720ms",
    repeatCount: "indefinite",
    type: "rotate",
    values: "0 64 64;45 64 64;90 64 64;135 64 64;180 64 64;225 64 64;270 64 64;315 64 64"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.625feac3c8b9392fea8bea82c8089acc.svg";
export { ForwardRef as ReactComponent };